"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function SankeyNode(_ref) {
  let {
    image,
    width,
    height,
    color,
    title,
    id,
    styles
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    style: styles
  }, image ? /*#__PURE__*/_react.default.createElement("img", {
    style: {
      width: '80%',
      height: '80%',
      margin: '5px'
    },
    src: image
  }) : /*#__PURE__*/_react.default.createElement("div", {
    style: {
      borderRadius: '50%',
      width: '60%',
      height: '60%',
      alignSelf: 'center',
      backgroundColor: 'rgba(100,100,100,0.15)'
    }
  }), /*#__PURE__*/_react.default.createElement("h6", {
    style: {
      position: 'absolute',
      transform: 'translate(0px,-44px)'
    }
  }, title));
}

var _default = SankeyNode;
exports.default = _default;